import { site } from './constants'

export function getConfig(p = {}) {
    const { config = {} } = p
    const commonConfig = config.common || {}

    const common = {
        ...commonConfig,
        lang: 'hu_HU',
        siteName: site.name,
        description: site.description
    }

    return {
        config: {
            ...config,
            common
        }
    }
}
